import axios from "axios"

export default {
  surveyResponse: {
    get: {
      surveyResponse: ({surveyResponseId}) => axios.get('/api/survey-responses/' + surveyResponseId).then(res => res.data),
      questionsListPreview: (data) => axios.post('/api/survey-responses/questions-list-preview', data).then(res => res.data),
    },
    post: {
      surveyResponse: ({guid, subguid, questionId, surveyResponseId, pausedResponseId, refId, qr, from, edit, isMobile, success}) => {
        let data = {
          guid,
        };
        if(subguid){
          data = {...data, subguid };
        }
        if(questionId){
          data = {...data, questionId };
        }
        if(surveyResponseId){
          data = {...data, surveyResponseId };
        }
        if(pausedResponseId){
          data = {...data, pausedResponseId };
        }
        if(refId){
          data = {...data, refId };
        }
        if(qr){
          data = {...data, qr };
        }
        if(from){
          data = {...data, from };
        }
        if (edit) {
          data = {...data, edit};
        }
        if (isMobile) {
          data = {...data, isMobile};
        }
        if (success) {
          data = {...data, success};
        }

        return axios.post('/api/survey-response', data).then(res => res.data);
      },
      questionResponse: ({surveyResponseId, questionResponses, _direction, microTime}) => {
        let data = { surveyResponse: {questionResponses, microTime}, _direction };

        return axios
        .post('/api/survey-responses/' + surveyResponseId + '/question-responses', data)
        .then(res => {
          if (res.headers.hasOwnProperty('redirect')) {
            window.location.replace(res.headers.redirect);
          } else {
            return res.data;
          }
        })
      },
      report: (surveyResponseId, data) => axios.post('/api/survey-responses/' + surveyResponseId + '/report', { data }).then(res => res.data)
    },
    getContinueLink: (surveyResponseId) => axios.get('/api/survey-response/' + surveyResponseId + '/continue').then(res => res.data.link),
    respondent: {
      browserInfo: ({surveyResponseId, browser}) => axios.patch('/api/survey-responses/' + surveyResponseId + '/browser', { browser }).then(res => res.data),
      register: (data, surveyResponseId) => axios.post('/register/post/' + surveyResponseId, data, { headers: { 'content-type': 'multipart/form-data' } }).then(res => res.data),
    },
    postRate: (surveyResponse, data) => axios.post('/api/survey-responses/' + surveyResponse.id + '/rates', { data }).then(res => res.data),
    postShare: (surveyResponse) => axios.post('/api/survey-responses/' + surveyResponse.id + '/shares'),
    patch: {
      params: ({surveyResponseId, params}) => axios.patch('/api/survey-responses/' + surveyResponseId + '/params', { params }).then(res => res.data),
    },
    postFile: (surveyResponseId, questionId, data) => axios.post('/api/survey-response/' + surveyResponseId +'/question/' + questionId + '/file', data, { headers: { 'content-type': 'multipart/form-data' } }).then(res => res.data.path),
    deleteFile: (surveyResponseId, questionId, filename) => axios.delete('/api/survey-response/' + surveyResponseId +'/question/' + questionId + '/file', {params: {filepath: filename}}),
    questionResponse: {
      open: {
        phone: {
          sendSms: (surveyResponse, question, phone) => axios.post('/api/survey-responses/' + surveyResponse.id + '/questions/' + question.id + '/send-sms', { phone }).then(res => res.data),
          checkCodeSms: (surveyResponse, question, phone, code) => axios.post('/api/survey-responses/' + surveyResponse.id + '/questions/' + question.id + '/check-code-sms', { phone, code }),
        },
        email: {
          send: (surveyResponse, question, email) => axios.post('/api/survey-responses/' + surveyResponse.id + '/questions/' + question.id + '/email-verify-send', { email }).then(res => res.data),
          verify: (surveyResponse, question, email, code) => axios.post('/api/survey-responses/' + surveyResponse.id + '/questions/' + question.id + '/email-verify-check', { email, code }),
        },
      }
    }
  },
  survey: {
    post: {
      password: (surveyId, password) => axios.post('/api/surveys/' + surveyId + '/password', password),
      contact: (surveyId, data) => axios.post('/api/surveys/' + surveyId + '/contact', {data}),
      report: (surveyId, data) => axios.post('/api/surveys/' + surveyId + '/reports', data),
    }
  },
  question: {
    post: {
      searchLibraryValues: (questionId, search) => axios.post('/api/questions/' + questionId + '/search-library-values', {search}).then(res => res.data),
    },
  },
  user: {
    login: (credentials) => axios.post('/api/sign/auth', { credentials }).then(res => res.data),
    updatePostalCode: data => axios.patch('/api/user-postal-code', data),
  }
}